<app-listing-layout>
  <ng-container listing-heading>
    <app-heading heading="All Cities"></app-heading>
  </ng-container>

  <ng-container listing-content>
    <div class="cities-form-card">
      <form class="cities-form" [formGroup]="form" (ngSubmit)="submit()">
        <mat-form-field appearance="outline">
          <mat-label>City Name</mat-label>
          <input matInput formControlName="cityName" placeholder="Gurgaon" />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>State</mat-label>
          <input matInput formControlName="state" placeholder="Haryana" />
        </mat-form-field>
      </form>

      <div class="form-actions">
        <button mat-raised-button color="primary" type="button" [disabled]="isSubmitting()" (click)="submit()">
          {{ isSubmitting() ? 'Saving...' : 'Post City' }}
        </button>
      </div>

      @if (submitSuccess()) {
      <p class="success-text">{{ submitSuccess() }}</p>
      }

      @if (submitError()) {
      <p class="fetch-error">{{ submitError() }}</p>
      }
    </div>

    @if (citiesVm$ | async; as vm) {
    @if (vm.error) {
    <p class="fetch-error">{{ vm.error }}</p>
    } @else if (vm.isLoading) {
    <p class="loading-text">Loading cities...</p>
    } @else if (!vm.items.length) {
    <p class="empty-text">No cities found.</p>
    } @else {
    <div class="table-shell">
      <div class="table-summary">
        <p class="summary-text">Showing {{ vm.items.length }} cit{{ vm.items.length === 1 ? 'y' : 'ies' }}</p>
      </div>

      <div class="table-scroll">
        <table mat-table [dataSource]="vm.items" class="cities-table">
          <ng-container matColumnDef="cityName">
            <th mat-header-cell *matHeaderCellDef>City Name</th>
            <td mat-cell *matCellDef="let item">{{ item.cityName || 'NA' }}</td>
          </ng-container>

          <ng-container matColumnDef="state">
            <th mat-header-cell *matHeaderCellDef>State</th>
            <td mat-cell *matCellDef="let item">{{ item.state || 'NA' }}</td>
          </ng-container>

          <ng-container matColumnDef="createdAt">
            <th mat-header-cell *matHeaderCellDef>Created At</th>
            <td mat-cell *matCellDef="let item">{{ formatDate(item.createdAt) }}</td>
          </ng-container>

          <ng-container matColumnDef="updatedAt">
            <th mat-header-cell *matHeaderCellDef>Updated At</th>
            <td mat-cell *matCellDef="let item">{{ formatDate(item.updatedAt) }}</td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="actions-column">Actions</th>
            <td mat-cell *matCellDef="let item" class="actions-column">
              <button
                mat-stroked-button
                color="warn"
                type="button"
                [disabled]="isDeleting(item.id)"
                (click)="deleteCity(item)"
              >
                {{ isDeleting(item.id) ? 'Deleting...' : 'Delete' }}
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
    </div>
    }
    }
  </ng-container>
</app-listing-layout>
